<div class="container-fluid glb-popup">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>
    <div [formGroup]="form1" class="forms w-100 d-block">
      <div class="row m-0">

        <div class="col-lg-12">
          @if (formAlert) {
            <div class="w-100 mb-3">
              <div class="w-100"
                style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                <p><b>{{formAlert}}</b></p>
              </div>
            </div>
          }
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="name" id="name" type="text" pInputText>
            <label for="name">Name</label>
            @for (validation of validationMessages.name; track validation) {
              <span>
                @if (form1.get('name').hasError(validation.type) && (form1.get('name').dirty || form1.get('name').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <p-dropdown class="w-100" [options]="statuses" formControlName="faqCategoryGroupId" optionLabel="name"
            optionValue="value" placeholder="Faq Category Group Name"></p-dropdown>
            <label for="faqCategoryGroupId">Group Name</label>
            @for (validation of validationMessages.faqCategoryGroupId; track validation) {
              <span>
                @if (form1.get('faqCategoryGroupId').hasError(validation.type) && (form1.get('faqCategoryGroupId').dirty || form1.get('faqCategoryGroupId').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-2">
          <div class="flex align-items-center">
            <p-checkbox [formControl]="form1.controls['enabled']" inputId="enabled" [binary]="true"></p-checkbox>
            <span class="faqCategory-nm">Enabled?</span>
          </div>
          @for (validation of validationMessages.enabled; track validation) {
            <span>
              @if (form1.get('enabled').hasError(validation.type) && (form1.get('enabled').dirty || form1.get('enabled').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </div>
        <div class="col-lg-4 button-group">
          <button pButton class="btn-cancel p-button-text p-button-outlined p-button" style="font-size: medium;"><a href="{{getLiveWebsiteUrl()}}"  target="_blank"><strong style="color: #3F51B5;">Go to live website</strong></a></button>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <textarea formControlName="description" id="description" [rows]="2" pInputTextarea></textarea>
            <label for="description">Short Description</label>
            @for (validation of validationMessages.description; track validation) {
              <span>
                @if (form1.get('description').hasError(validation.type) && (form1.get('description').dirty || form1.get('description').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <label for="introDesc"><strong>Intro Description :</strong></label>
          <span class="p-float-label w-100 mb-3">
            <!-- <ckeditor [editor]="editor" formControlName="opsNotes" id="opsNotes" (ready)="onReady($event)"></ckeditor> -->
            <editor
              formControlName="introDesc"
              id="introDesc"
						[init]="{
							height: 300,
							base_url: '/tinymce',
							suffix: '.min',
							plugins: 'code anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount',
      toolbar: 'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat'}" >
            </editor>
            @for (validation of validationMessages.introDesc; track validation) {
              <span>
                @if (form1.get('introDesc').hasError(validation.type) && (form1.get('introDesc').dirty || form1.get('introDesc').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <textarea formControlName="opsNotes" id="opsNotes" [rows]="2" pInputTextarea></textarea>
            <label for="opsNotes">Ops Notes</label>
            @for (validation of validationMessages.opsNotes; track validation) {
              <span>
                @if (form1.get('opsNotes').hasError(validation.type) && (form1.get('opsNotes').dirty || form1.get('opsNotes').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <!-- Scope Fields -->
        <div class="col-lg-12 mb-2">
          <hr>
          <h5>Scope <small class="text-muted">(optional — leave all blank for a global category that applies to all properties)</small></h5>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <p-dropdown class="w-100" [options]="propertyOptions" formControlName="shortTermRentalId"
              optionLabel="propertyCode" optionValue="shortTermRentalId" [showClear]="true" [filter]="true"
              filterBy="propertyCode" placeholder="Any property"></p-dropdown>
            <label for="shortTermRentalId">Property (shortTermRentalId)</label>
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <p-dropdown class="w-100" [options]="developmentOptions" formControlName="developmentId"
              optionLabel="addressDevelopmentName" optionValue="developmentId" [showClear]="true" [filter]="true"
              filterBy="addressDevelopmentName" placeholder="Any development"></p-dropdown>
            <label for="developmentId">Development (developmentId)</label>
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <p-dropdown class="w-100" [options]="locationOptions" formControlName="locationId"
              optionLabel="label" optionValue="value" [showClear]="true"
              placeholder="Any location"></p-dropdown>
            <label for="locationId">Location (locationId)</label>
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <p-dropdown class="w-100" [options]="adrRegionOptions" formControlName="adrRegion"
              optionLabel="label" optionValue="value" [showClear]="true"
              placeholder="Any region"></p-dropdown>
            <label for="adrRegion">Region (adrRegion)</label>
          </span>
        </div>

      </div>
    </div>
    @if (faqCategoryId) {
      <app-faq-section-list [faqCategoryId]="faqCategoryId" [showFilter]="false" [showPagination]="showPagination" [outlineNewButton]="false"></app-faq-section-list>
    }
    <hr>
      <div class="row m-0">
        <div class="col-lg-12">
          <div class="btn-group">
            <div class="button-group">
              @if (faqCategoryId) {
                <button pButton class="btn-delete p-button-outlined p-button-danger"
                (click)="onFormDelete()">Delete</button>
              }
            </div>

            <div class="button-group">
              <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
              @if (!faqCategoryId) {
                <button pButton class="btn-addt p-button" (click)="formAdd()">Add</button>
              }

              @if (faqCategoryId) {
                <button pButton  class="btn-upt p-button" (click)="formUpdate()">Update</button>
              }
            </div>
          </div>
        </div>
      </div>
    </div>